
<template>
    <div class="body_area">
        <div class="block-header">
            <div class="container">
                <div class="row clearfix">
                    <div class="col-lg-6 col-md-12">
                        <!-- <ul class="breadcrumb pl-0 pb-0 ">
                                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                        <li class="breadcrumb-item">Forms</li>
                                        <li class="breadcrumb-item active">Basic Elements</li>
                                    </ul> -->
                        <!--            <i class="zmdi zmdi-account"></i>-->
                        <h1 class="mb-1 mt-1"><font-awesome-icon :icon="faUserAlt"/> 계정</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <!-- Input -->
            <div class="row clearfix row-deck">
                <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="card member-card">
                        <div class="header bg-primary">
                            <h4 class="mt-3 text-light" style="font-size: 100%;">{{ name }}</h4>
                        </div>
                        <div class="member-img">
                            <img
                                src="@/assets/images/blog/11-img.jpg"
                                class="rounded-circle"
                                alt="profile-image"
                            />
                        </div>
                        <div class="body">
                            <div class="col-12">
                                <h6 class="mb-0">회사코드</h6>
                                <p>{{this.$store.state.userStore.userCode}}</p>
                            </div>
                            <hr />
                            <div class="col-12">
                                <!-- <ul class="social-links list-unstyled">
                                                    <li><a title="facebook" href="javascript:void(0);"><i class="zmdi zmdi-facebook"></i></a></li>
                                                    <li><a title="twitter" href="javascript:void(0);"><i class="zmdi zmdi-twitter"></i></a></li>
                                                    <li><a title="instagram" href="javascript:void(0);"><i class="zmdi zmdi-instagram"></i></a></li>
                                                </ul> -->
                                <p class="text-muted"><b>{{planName}} </b></p>
                                <!--                <p class="text-muted">{{ memo }}</p>-->
                            </div>
                            <hr />
                            <div class="row clearfix">
                                <div class="col-sm-7">
                                    <select class="form-control show-tick" id="taskSelectBox" v-model="dateOfSearch">
                                        <option v-for="(option, index) in options" :key="index" :value="option.value">{{option.text}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-5">
                                    <button type="button" class="btn btn-primary text-white" @click="getTasks">조회</button>
                                    <!--                  ::{{dateOfSearch}}-->
                                </div>
                            </div>
                            <hr />
                            <div class="row clearfix">
                                <div class="col-12">
                                    <h6 class="mb-0">리드</h6> :
                                    <small>{{leadCount}} / {{leadTotal}}</small>
                                    <hr>
                                    <h6 class="mb-0">Works</h6> :
                                    <small>{{workCount}} / {{workTotal}}</small>

                                    <hr>
                                    <h6 class="mb-0">Flow</h6> :
                                    <small>{{flowCount}} / {{flowTotal}}</small>
                                    <hr>
                                    <h6 class="mb-0">계약구분</h6> :
                                    <small>{{adjustType}} </small>
                                    <hr>
                                    <h6 class="mb-0">기간</h6> :
                                    <small>{{adjustTerm}} </small>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9 col-md-6 col-sm-12">
                    <div class="card">
                        <div class="body">
                            <h2 class="card-inside-title">이메일</h2>
                            <div class="row clearfix">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="v@v.com"
                                            :value="email"
                                            readonly
                                        />
                                    </div>
                                    <!-- <div class="form-group">
                                                          <input type="password" class="form-control" placeholder="Password" />
                                                      </div> -->
                                </div>
                            </div>

                            <h2 class="card-inside-title">이름</h2>
                            <div class="row clearfix">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="이름"
                                            maxlength="50"
                                            v-model="name"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <button
                                        class="btn btn-primary"
                                        style="float: right"
                                        @click="editProfileData(0)"
                                    >
                                        저장
                                    </button>
                                </div>
                            </div>

                            <h2 class="card-inside-title">비밀번호 변경</h2>
                            <div class="row clearfix">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="password"
                                            class="form-control"
                                            maxlength="50"
                                            v-model="password1"
                                            placeholder="기존 비밀번호"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="password"
                                            class="form-control"
                                            maxlength="50"
                                            v-model="password2"
                                            placeholder="새 비밀번호"
                                        />
                                        <span v-if="password2 != null && password2.length < 8">비밀번호는 8자리 이상입니다.</span>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="password"
                                            class="form-control"
                                            maxlength="50"
                                            v-model="password3"
                                            placeholder="새 비밀번호 확인"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <button
                                        class="btn btn-primary"
                                        style="float: right"
                                        @click="editProfileData(1)"
                                    >
                                        저장
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- #END# Input -->
            <!-- <footer-view /> -->

            <plan-page v-bind:planType="planType" />

            <div class="row clearfix row-deck">
                <div class="col-lg-12 col-md-6 col-sm-12">
                    <div class="card">
                        <div class="body">
                            <h2 class="card-inside-title">회원 탈퇴</h2>
                            <div class="row clearfix">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <b
                                        >
                                            <font-awesome-icon :icon="faMinus" />
                                            탈퇴 후에도 생성하신 앱은
                                            그대로 남아있습니다.</b
                                        ><br />
                                        &nbsp;&nbsp;&nbsp;삭제를 원하시는 앱은 탈퇴 전
                                        <span style="color: red">반드시 삭제하시기 바랍니다.</span
                                        ><br />
                                        <br />
                                    </div>
                                    <div class="form-group">
                                        <b
                                        >
                                            <font-awesome-icon :icon="faMinus" /> 탈퇴 후 같은 이메일로
                                            재가입은 불가합니다.</b
                                        ><br />

                                        <br />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="c_checkbox">
                                            <input
                                                type="checkbox"
                                                value="checked"
                                                v-model="booleanDelete"
                                            />
                                            <span class="checkmark"></span>
                                            <span class="ml-2">위의 사항을 확인했습니다.</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <button
                                        class="btn btn-primary"
                                        style="float: right"
                                        ref="deleteBtn"
                                        v-bind:disabled="!booleanDelete"
                                        @click="removeAccount"
                                    >
                                        회원탈퇴
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <pay-modal />

            <footer-view />
        </div>
    </div>
</template>

<script>
import FooterView from "@/components/common/FooterView.vue";
import PlanPage from "@/views/company/PlanPage";
import PayModal from "@/components/user/modal/payModal";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faUserAlt} from "@fortawesome/free-solid-svg-icons";
import { faMinus } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "ProfilePage",
    components: {
        FooterView: FooterView,
        PlanPage: PlanPage,
        PayModal : PayModal,
        FontAwesomeIcon,
    },

    data() {
        return {
            siteCode : null,
            code: null,
            email: null,
            name: null,
            memo: '',

            password1: null,
            password2: null,
            password3: null,

            planName : null,
            planType : null,
            flowCount : 0,
            flowTotal : 0,
            workCount : 0,
            workTotal : 0,
            leadCount : 0,
            leadTotal : 0,

            startDt : "",
            endDt : "",
            adjustType : "",
            adjustTerm : "",


            dateOfSearch : "",
            options : [
                {text : '전체', value : ''}
            ],

            booleanDelete: false,

            faUserAlt,
            faMinus,
        };
    },
    methods: {
        addZeroInMonth(num){
            if(num > 0 && num < 10){
                return "0" + num
            } else if(num == 0){
                return "12"
            } else {
                return String(num);

            }
        },
        getYearMonth(year, month){
            if(month == "12"){
                return year - 1;
            } else {
                return year;
            }
        },
        editProfileData(val) {
            if (val == 0) { //이름 변경

                // this.name = this.name.replace(" ", "");
                if (this.name.length < 0) {
                    alert("이름을 입력해주세요.");
                    return;
                }
            } else if (val == 1) {
                console.log(this.password1);
                console.log( this.$store.state.userStore.userName.userPw);
                console.log(this.userPw);

                if(this.password1 == null || this.password1.length < 8) {
                    alert("현재 비밀번호를 입력해주세요");
                    return;
                }
                // if(this.password1 !=  this.userPw ){
                //   alert("현재 비밀번호를 맞지 않습니다. 다시 입력해주세요.");
                //   return;
                // }
                if (this.password2 == null ) {
                    alert("새 비밀번호를 입력해주세요.");
                    return;
                }
                else if(this.password3 == null){
                    alert("새 비밀번호 확인을 입력해주세요.");
                    return;
                }
                if(this.password2.length < 8){
                    alert("비밀번호는 8자리 이상입니다.")
                    return
                }
                if (this.password2 != this.password3) {
                    alert("새 비밀번호가 맞지 않습니다. 다시 입력해주세요.");
                    return;
                }
            }


            var param = {
                companyCode: this.$store.getters.getUserCode,
                userEmail: this.email,
                userName: this.name,
                userPw: this.password1,
                changePw: this.password2,
                type: val
            }

            console.log(param);
            console.log(val);

            this.api.updateUserProfile(param)
                .then((res) => {
                    console.log(res);

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }

                    if (res.code == 0) {
                        this.$store.dispatch("setUserName", {name : this.name})
                        // this.$store.state.userStore.userName = this.name;
                        alert("변경되었습니다.");

                        // this.$router.push('/')
                    } else {
                        alert(res.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeAccount() {
            if (confirm("탈퇴하시겠습니까?")) {
                this.api.removeAccount({userCode: this.$store.state.userStore.userCode})
                    .then((res) => {

                        if(this.utils.preApiHandle(res)) {
                            console.log("profile remove res : ", res)
                        }

                        console.log(res);
                        if (res.code == 0) {
                            alert("탈퇴되었습니다.");

                            this.$store.dispatch("logout");
                            this.$router.push("/");
                        } else {
                            alert(res.message);
                            //} else {
                            //    alert("에러가 발생했습니다.");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                return;
            }
        },
        getTasks(){

            console.log("task")


            var madeOptions = document.getElementsByClassName("makeOptions")
            for(var i =0; i < madeOptions.length; i++){
                document.getElementById("taskSelectBox").removeChild(madeOptions[i]);
            }

            this.api.getUserTask({
                companyCode : this.$store.state.userStore.userCode,
                dateOfSearch : this.dateOfSearch,
                siteCode : this.$store.state.userStore.siteCode
            })
                .then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile create res : ", res)
                    }

                    console.log(res)
                    if (res.code == 0) {
                        console.log(res);
                        this.planName = res.task.planName;
                        this.flowCount = res.task.flowCount;
                        this.flowTotal = res.task.flowTotal;
                        this.workCount = res.task.workCount + res.task.serviceLogCount;
                        this.workTotal = res.task.workTotal;
                        this.leadCount = res.task.leadCount;
                        this.leadTotal = res.task.leadTotal;
                        this.planType = res.task.planName;


                        this.startDt = res.task.startDt;
                        this.endDt = res.task.endDt;
                        this.adjustType = res.task.adjustType;

                        if(this.adjustType == "PAYMENT") {
                            this.adjustType = "결제";
                        } else if(this.adjustType == "CONTRACT") {
                            this.adjustType = "계약";
                        } else if(this.adjustType == "FREE") {
                            this.adjustType = "무료";
                        }

                        this.workCount += this.leadCount;

                        if(this.flowTotal == -1) {
                            this.flowTotal = "∞";
                        }

                        this.adjustTerm = this.startDt.split(' ')[0] + " ~ " + this.endDt;

                        this.dateOfSearch = res.task.dateOfSearch;

                        this.setTaskSelectOptionBox(res.task);

                    } else {

                        alert("오류가 발생했습니다.");
                        // location.href="/";
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setTaskSelectOptionBox(task){


            this.options = [
                {text : '전체', value : ''}
            ]


            var year = Number(task.startDt.split("-")[0]);
            var month = Number(task.startDt.split("-")[1]);

            var planDate = new Date();
            planDate.setFullYear(year);
            planDate.setMonth(month);
            planDate.setDate(1);
            var date = new Date();
            date.setDate(2);

            date.setMonth(date.getMonth() + 1)

            //
            // console.log(planDate < date)
            // console.log(year)
            // console.log(month)
            // console.log(planDate)

            while(planDate < date){
                console.log("날짜", planDate)

                var planYear = planDate.getFullYear();
                var planMonth = planDate.getMonth();
                console.log("날짜", this.getYearMonth(planYear, this.addZeroInMonth(planMonth)) + "-" + this.addZeroInMonth(planMonth))

                var dateString = this.getYearMonth(planYear, this.addZeroInMonth(planMonth)) + "-" + this.addZeroInMonth(planMonth);
                this.options.push({text : dateString , value : dateString })

                // console.log("while :", planYear  + "/"+ planMonth + "/"+ planDate )
                planDate.setMonth(planMonth + 1);

            }

        }
    },
    computed: {},
    created() {
        console.log("ProfilePage.created");

        // var madeOptions = document.getElementsByClassName("makeOptions")
        // for(var i =0; i < madeOptions.length; i++){
        //   document.getElementById("taskSelectBox").removeChild(madeOptions[i]);
        // }


        console.log(this.$store.state.userStore.userCode)

        // this.api.getProfile({userCode : this.$store.state.userStore.userCode})
        //   .then((res) => {
        //
        //     if(this.utils.preApiHandle(res)) {
        //       console.log("profile create res : ", res)
        //     }
        //
        //     console.log(res)
        //     if (res.code == 0) {
        //       console.log(res);
        //         this.code = res.user.userCode;
        //         this.email = res.user.userEmail;
        //         this.name = res.user.companyName;
        //         this.memo = res.user.memo;
        //       } else {
        //
        //         alert("오류가 발생했습니다.");
        //         // location.href="/";
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });

        this.api.getUserProfile({companyCode : this.$store.state.userStore.userCode})
            .then((res) => {

                if(this.utils.preApiHandle(res)) {
                    console.log("profile create res : ", res)
                }

                console.log(res)
                if (res.code == 0) {
                    console.log(res);
                    this.code = res.user.userCode;
                    this.email = res.user.userEmail;
                    this.name = res.user.companyName;
                    this.siteCode = res.user.siteCode;

                    this.getTasks();


                } else {

                    alert("오류가 발생했습니다.");
                    location.href="/";
                }
            })
            .catch((error) => {
                console.log(error);
            });





    },
    mounted() {
        console.log("ProfilePage.mounted");
    },
    beforeDestroy() {
        console.log("ProfilePage.beforeDestroy");
    }
}
</script>
